import axios from "axios";
//const API_URL = 'https://apiCOMITE.kairosmining.com/auth/'
//const API_URL = 'http://10.63.0.152:8080/auth/';
const API_URL = window.Configs + '/auth/' 

const register = (username, email, password) => {
  return axios.post(window.Configs.URLSERVER + '/auth/' +  "signup", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(window.Configs.URLSERVER + '/auth/' +  "login", {Username: username,Password: password})
    .then((response) => {
      if (response.data) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }        
      return response;
    }).catch((error)=>{
      console.log(error.response.data);
      return error.response.data;
    });
};

const changePassword = (idUser, oldPass, newPass) => {
  return axios
    .post(window.Configs.URLSERVER + '/auth/' +  "changePassword", {
      idUser: idUser,
      oldPass: oldPass,
      newPass: newPass,
    })
    .then((response) => {
      // console.log(response);
      if (response.data) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }        
      return response;
    }).catch((error)=>{
      // console.log(error.response.data);
      return error.response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const exportedObject = {
  register,
  login,
  logout,
  getCurrentUser,
  changePassword
}

export default exportedObject